import React, { useState } from "react";

export default function PassEye({
  onChange,
  value = "",
  name = "password",
  autoComplete = "current-password",
}) {
  const [showPassword, setShowPassword] = useState(false);

  const toggleShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <input
        type={showPassword ? "text" : "password"}
        name={name}
        autoComplete={autoComplete}
        className="login"
        placeholder="Hasło"
        value={value}
        onChange={onChange}
        style={{
          height: "25px",
          width: "270px",
          fontWeight: "normal",
          appearance: "none",
          outline: "none",
          backgroundColor: "rgb(250,250,250)",
          padding: "6px 30px",
          color: "rgb(20,20,20)",
          border: "1px solid rgb(30,30,30)",
          borderRadius: "5px",
          backgroundImage: `url(${process.env.PUBLIC_URL + "/pass.png"})`,
          backgroundSize: "17px",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "8px 9.5px",
          paddingLeft: "40px",
          transition: "0.8s",
        }}
      />

      <span
        onClick={toggleShowPassword}
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          marginTop: "3px",
        }}
      >
        {showPassword ? (
          <img src="eyeClosed.png" style={{ width: "20px", opacity: "0.65" }} />
        ) : (
          <img src="eye.png" style={{ width: "20px", opacity: "0.65" }} />
        )}
      </span>
    </div>
  );
}